import * as type from '../actions/types';

const initialState = {
  data: {},
  pending: true,
  error: '',
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_ACTIVE_OFFERS_PENDING:
      return {
        ...state,
        data: [],
        pending: true,
        error: '',
      };
    case type.FETCH_ACTIVE_OFFERS_SUCCESS:
      const { data } = action.payload;
      return {
        ...state,
        data,
        pending: false,
        success: true,
      };
    case type.FETCH_ACTIVE_OFFERS_FAILURE:
      return {
        ...state,
        data: [],
        error: action.payload,
        pending: false,
      };

    default:
      return state;
  }
};
